import constants from 'constants/constants';

import { Widget } from 'components/Dashboards/Reporting/reporting.types';

export const CommonExportConstants = {
    DARK_BLUE_COLOR: '#12223E',
};

// Get unique project-contract combinations from report widgets
interface ProjectContractRecord {
    project: string;
    contract: string;
}
export type ProjectContracts = ProjectContractRecord[];
export const getUniqueProjectContracts = (reportWidgets: Widget[]): ProjectContracts => {
    const uniqueCombinations = new Map<string, ProjectContractRecord>();

    // Filter out widgets without project and contract
    const widgetsWithProjectsAndContracts = reportWidgets.filter(
        (widget) =>
            widget.projectId !== constants.NO_PROJECT_CONTRACT_ID ||
            widget.contractId !== constants.NO_PROJECT_CONTRACT_ID,
    );

    widgetsWithProjectsAndContracts.forEach((widget) => {
        const project = widget.projectName || '';
        const contract = widget.contractName || '';
        const key = `${project}|${contract}`;

        if (project && contract && !uniqueCombinations.has(key)) {
            uniqueCombinations.set(key, { project, contract });
        }
    });

    return Array.from(uniqueCombinations.values());
};
